import { sandhillsRequest, gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import { gtmEventType } from '@Components/Utilities/SandhillsConstants';
import { useState, useEffect } from 'react';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';

const SEOLinkWindow = loadable(() =>import('@Components/Listings/SEOLinkWindow'));

const SEOLinks = (props) => {

    const buildLinkGroupDictionary = (InternalLinkGroups) => {
        let mappedDict = {};
        InternalLinkGroups.map((group) => {
            mappedDict[group.Name] = group.InternalLinkColumns;
        });
        return mappedDict;
    };

    const initialDictionary = buildLinkGroupDictionary(props.InternalLinkGroups);
    const [facetOpen, setFacetOpen] = useState(null);
    const [currentlyLoadingGroup, setCurrentlyLoadingGroup] = useState(null);
    const [mappedDictionary, setMappedDictionary] = useState(initialDictionary);

    useEffect(function updateDictionary() {
        if (props.LoadInternalLinksOnDemand) {
            let mappedDictionaryCopy = mappedDictionary;
            props.InternalLinkGroups.map((group) => {
                mappedDictionaryCopy[group.Name] = group.InternalLinkColumns;
            });
            setMappedDictionary(mappedDictionaryCopy);
        }
        setFacetOpen(null);
    }, [props.SearchURL]);

    const buildAjaxSearchURL = (searchURL, ajaxLoadURL) => {
        let ajaxKeyword = 'ajaxsearch?';
        let sliceIndex = searchURL.indexOf(ajaxKeyword) + ajaxKeyword.length;
        let currentQueryString = '&' + searchURL.slice(sliceIndex);
        let searchUrl = ('' + ajaxLoadURL + currentQueryString);
        return searchUrl;
    };

    const changeActive = (propertyName, ajaxURL) => {
        if (!currentlyLoadingGroup) {
            if (props.LoadInternalLinksOnDemand && mappedDictionary[propertyName] && mappedDictionary[propertyName].length === 0) {
                setCurrentlyLoadingGroup(propertyName);
                let fullAjaxLoadURL = buildAjaxSearchURL(props.SearchURL, ajaxURL);
                sandhillsRequest({
                    url: fullAjaxLoadURL,
                    errorHandling: {
                        message: 'Error retrieving internal links',
                        showDetails: true,
                        useConsole: true,
                        useAlert: false
                    }
                }).then((response) => {
                    let newMappedDictionary = mappedDictionary;
                    newMappedDictionary[propertyName] = response;
                    setFacetOpen(propertyName);
                    setCurrentlyLoadingGroup(null);
                    setMappedDictionary(newMappedDictionary);
                });
            } else {
                setFacetOpen(propertyName);
            }
        }
    };

    return (
        <div>
            <div className='linking-buttons'>
                <ul>
                    {props.InternalLinkGroups && props.InternalLinkGroups.map(group =>
                        <li key={'linking-buttons-' + group.ReactKey}>
                            {(currentlyLoadingGroup && currentlyLoadingGroup === group.Name) &&
                                <LoadingRing backdrop />}
                            {group.DrilldownPageUrl ? 
                                <a href={group.DrilldownPageUrl}>
                                    {group.DisplayText}
                                </a>
                                :
                                <a className={group.Name === facetOpen ? 'active' : ''} onClick={() => { changeActive(group.Name, group.AjaxLoadUrl); gtmPushEvent(gtmEventType.internalLinkExpanded); }} tabIndex='0' role="button" onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        changeActive(group.Name, group.AjaxLoadUrl);
                                    }
                                }}>
                                    {group.DisplayText}
                                </a>
                             }
                        </li>)}
                </ul>
            </div>
            <div>
                {props.InternalLinkGroups && props.InternalLinkGroups.map(group =>
                    <div key={group.ReactKey} style={{ display: group.Name === facetOpen ? 'block' : 'none' }}>
                        <SEOLinkWindow InternalLinkGroup={group} InternalLinkColumns={props.LoadInternalLinksOnDemand ? mappedDictionary[group.Name] : group.InternalLinkColumns} IsHostedSite={props.IsHostedSite} />
                    </div>)}
            </div>
        </div>
    );
};

export default SEOLinks;